import React from 'react';

interface ButtonProps {
  onClick?: () => void;
  type?: 'button' | 'submit';
  children: React.ReactNode;
  className?: string; // Additional className
  variant?: 'primary' | 'secondary' | 'success' | 'danger'; // Button variants
  disabled?: boolean;
  isLoading?: boolean;
}

const Button: React.FC<ButtonProps> = ({
  onClick,
  type = 'button',
  children,
  className,
  variant = 'primary',
  disabled = false,
  isLoading = false,
}) => {
  const baseClasses = 'px-6 py-2 transition-colors text-sm font-medium rounded';

  // Define classes for each button variant with dark mode styles
  const variantClasses = {
    primary:
      'bg-gray-800 text-white shadow-gray-500 shadow-sm hover:shadow-gray-400 hover:shadow-md dark:bg-gray-700 dark:text-gray-200 dark:shadow-gray-900',
    secondary:
      'bg-customSecondary text-white shadow-gray-500 shadow-sm hover:shadow-gray-600 hover:shadow-md dark:border-gray-600 dark:bg-gray-900 dark:text-gray-300 dark:shadow-gray-900',
    success:
      'bg-green-500 text-white hover:bg-green-600 dark:bg-green-600 dark:hover:bg-green-500',
    danger:
      'bg-red-500 text-white hover:bg-red-600 dark:bg-red-600 dark:hover:bg-red-500',
  };

  // Apply base classes, variant classes, and additional className
  return (
    <button
      type={type}
      onClick={onClick}
      className={`${baseClasses} ${variantClasses[variant]} ${className || ''}`}
      disabled={disabled}
    >
      {isLoading ? (
          <>
            <div className="flex items-center justify-center">
              {children}
              <span className="ml-2 spinner-border animate-spin inline-block w-4 h-4 border-2 rounded-full border-t-white"></span>
            </div>
          </>
      ) : (
          children
      )}
    </button>
  );
};

export default Button;
